import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const CustomCodeActionDetail = () => {
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "automation-ui-action-features.action-features.custom-code.actionDescription"
  });
};
export default CustomCodeActionDetail;